import { useRef, useState, useSyncExternalStore } from "react";

import { uploadToStorage } from "@/adapters/api";
import {
	documentErrorMessage,
	isDocumentUploadRestartRequired,
} from "../utils/errors.ts";
import { UploadQueue } from "../utils/upload-queue.ts";
import { useCompleteUpload } from "./use-complete-upload.ts";
import { useStartUpload } from "./use-start-upload.ts";

export function useUploadQueue(constructionId: string | undefined) {
	const startUpload = useStartUpload(constructionId);
	const completeUpload = useCompleteUpload(constructionId);
	const mutations = useRef({ startUpload, completeUpload });
	mutations.current = { startUpload, completeUpload };

	const [queue] = useState(
		() =>
			new UploadQueue({
				start: (file, options) =>
					mutations.current.startUpload.mutateAsync({ file, ...options }),
				upload: uploadToStorage,
				complete: (documentId) =>
					mutations.current.completeUpload.mutateAsync(documentId),
				errorMessage: (err) =>
					documentErrorMessage(err, "Não foi possível enviar o arquivo."),
				restartRequired: isDocumentUploadRestartRequired,
			}),
	);

	const items = useSyncExternalStore(queue.subscribe, queue.getSnapshot);

	return { queue, items };
}
